import "../../styles/style.css";

import isEmpty from "lodash/isEmpty";
import React, { Component, Fragment } from "react";

import { getPostTitle } from "../../helper/helper";
import { IMAGES } from "../../constants/constants";

class PostHeader extends Component {
  render() {
    const { post, selectedUser, isClickable, manageOptionOverlay } = this.props;
    return (
      <Fragment>
        {post.auditInfo && post.auditInfo.createdTime && isClickable && (
          <div className="feed-post-card-content">
            <div className="feed-post-card-meta">
              <span className="feed-author-name">
                {!isEmpty(selectedUser)
                  ? selectedUser.displayName
                  : post.auditInfo && post.auditInfo.createdBy
                  ? post.auditInfo.createdBy
                  : ''}
              </span>
              <div className="feed-post-card-meta-right">
                <span className="feed-card-date">
                  {new Date(
                    post.auditInfo.createdTime._seconds
                      ? post.auditInfo.createdTime._seconds * 1000
                      : post.auditInfo.createdTime
                  ).toDateString()}
                </span>
                <img
                  alt="options"
                  src={IMAGES.THREE_DOTS.default}
                  className="feed-card-three-dots"
                  onClick={() => manageOptionOverlay(post.id, post.private)}
                />
              </div>
            </div>
            {!isEmpty(post.title) && (
              <p className="feed-card-title">{getPostTitle(post.title)}</p>
            )}
            {!isEmpty(post.place) && (
              <span className="feed-card-location">
                <i className="icon icon-map-marker icon-rotate-360"></i>
                &nbsp;{post.place}
              </span>
            )}
          </div>
        )}
        {post.auditInfo && post.auditInfo.createdTime && !isClickable && (
          <div className="post-header-main">
            <div className="post-header-text">
              {!isEmpty(post.title) ? (
                <p className="post-title">{getPostTitle(post.title)}</p>
              ) : !isEmpty(selectedUser) ? (
                <span className="post-user-name">{selectedUser.displayName}</span>
              ) : (
                post.auditInfo &&
                post.auditInfo.createdBy && (
                  <span className="post-user-name">{post.auditInfo.createdBy}</span>
                )
              )}
              <img
                alt="three-dots-icon"
                src={IMAGES.THREE_DOTS.default}
                className="three-dots-icon"
                onClick={() => manageOptionOverlay(post.id, post.private)}
              />
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default PostHeader;
